import styled from '@emotion/styled';
import { useAtom }          from "jotai";
import { useGetPayCheck }   from "hooks/api";
import { usePostPayple }    from 'hooks/api';
import { useEffect, useState }        from 'react';
import { checkedBoxesAtom } from "components/pages/Onboarding/onboardingAtom";
import { Button } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

const Elem:React.FC<any> = () => {
  const { mutateAsync : postPayple } = usePostPayple();
  const [ checkboxes, setCheckboxes ] = useAtom(checkedBoxesAtom);
  const payCheckData = useGetPayCheck()
  const [ showModal, setShowModal ] = useState<boolean>(false);
  const [ payModal, setPayModal ] = useState<boolean>(false);
  const [ url, setUrl ] = useState("");
  const navigator = useNavigate();

  const handlePaypleRegistration = async () => {
    const policyParams = {
      termsCondition : checkboxes.termsCondition,
      personalInformation : checkboxes.personalInformation,
      marketingConstent : checkboxes.marketingConstent
    };

    const paypleResponse = await postPayple(policyParams);
    const redirectUrl = await paypleResponse.data?.pay;
    return redirectUrl
  };

  if (payCheckData.data?.status === 200){
    window.location.href="/onboarding/5/complete"
  }

  const handleButtonClick = () => {
    navigator("/onboarding/4/credit");
  };

  const handleCloseModal = async () => {
    setPayModal(false);
    setUrl('');
  };

  useEffect(() => {
    let timer:any;
    let newWindow: any;

    const handlePopupBlock = () => {
      setShowModal(true);
    };


    const fetchDataWithDelay = async () => {
      try {        
        const redirectUrl = await handlePaypleRegistration();
        setUrl(redirectUrl)
        // const openUrl = `${redirectUrl}?id=Payple`
        // newWindow = window.open(openUrl, "MyWindow");

        // if (newWindow === null || typeof newWindow === "undefined") {
        //   handlePopupBlock()
        // } else {
          //팝업이 저상적으로 열림(팝업 차단이 해제됨)
          console.log("폴링을 백그라운드에서 수행 중...");
          setPayModal(true)
          timer = setInterval(async () => {
            const updatedPayCheckData = await payCheckData.refetch();
            if (updatedPayCheckData.data?.status === 200) {
              // 폴링 결과가 성공적으로 완료됨
              clearInterval(timer);
              console.log("폴링이 완료되었습니다.");
              await handleCloseModal();
              window.location.href="/onboarding/5/complete"
            }
          }, 2000);
        // }
        } catch(error) {
          //에러처리
        }
      };

    //컴포턴트가 마운트되었을 때 초기 요청
    fetchDataWithDelay();
    //컴포넌트가 언마운트되면 타이머 해제
    return () => {
      clearTimeout(timer);
      newWindow?.close();
    }
  },[]);

  return (
    <>
    {/* {showModal && (
        <Background>
          <ModalContainer>
            <TextContainer>
              <BoldText>팝업이 차단되었습니다.</BoldText>
              <SmallText>팝업 차단을 해제하고 다시 시도해주세요.</SmallText>
            </TextContainer>
            <ButtonWrapper>
              <Button 
                layoutVariant="contained"
                variant="default"
                expand
                onClick={() => handleButtonClick()}>돌아가기</Button>
            </ButtonWrapper>
          </ModalContainer>
        </Background>
      )} */}
    {payModal && (
      <PaypleModal
        isOpen={payModal}
        onRequestClose={handleCloseModal}
        contentLabel="URL Modal"
      >
      <URLframe 
        src={url}
        title="URL Frame"
        />
      </PaypleModal>
      )}
    </>
  )
};

export default Elem;

const Background = styled.div`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0,0,0,0.50);
  z-index: 0;
`
const ModalContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: scroll;
  max-height: 80%;
  width: 343px;
  height: 231px;
  background-color: white;
  text-align: center;
  display:flex;
  flex-direction: column;
`;

const TextContainer =styled.div`
  width: 211px;
  height: 57px;
  margin: 42px auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const BoldText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 23px;
  line-height: 133%;
  text-align: center;
  color: #000000;
`;
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 100%;
  text-align: center;
  color: #141414;
`;
const ButtonWrapper = styled.div`
  width: 295px;
  height: 47px;
  margin: 0 auto;
`;
const PaypleModal = styled(Modal)`
  width: 100%;
  height: 100%;
`
const URLframe = styled.iframe`
  width: 100%;
  height: 100%;
`;

